import { getCampaignsApiRequest } from '@/services/api/campaign-api';
import { StatusEnum } from '@/services/models/Enums';
import { useStore } from '@/store';

export const populateCampaignsStoreCacheApiRequest = async (): Promise<Bemob.Campaign[]> => {
  const store = useStore();
  store.cache.cacheStartUpdating({ cacheProperty: 'campaigns' });
  const payload = await getCampaignsApiRequest({
    status: StatusEnum.active,
    limit: 200,
    orderBy: 'updated',
    orderDirection: 'desc',
  });
  store.cache.populateCampaignsCache(payload);
  return payload;
};

export const updateCampaignsStoreCacheApiRequest = async (
  workspaceId: string,
): Promise<Bemob.Campaign[]> => {
  const store = useStore();
  const payload = await getCampaignsApiRequest({
    status: StatusEnum.active,
    limit: 200,
    orderBy: 'updated',
    orderDirection: 'desc',
    workspaceIds: [workspaceId],
  });
  store.cache.updateCampaignsCache({ workspaceId, data: payload });
  return payload;
};
